<div class="form-subcontainer">
  <div class="form-content">
    <div>
      <form [formGroup]="formGroup" formName="paymentFilter" (ngSubmit)="confirm()" class="fpx-form-group">
        <section class="request-details-sec">
          <div class="details-entry-panel">
            <div class="fpx-field">
              <app-to-date label="{{ 'PAYMENTFILTER.fromDate' | translate }}" formControlName="fromDate">
              </app-to-date>
            </div>
            <div class="fpx-field">
              <app-to-date label="{{ 'PAYMENTFILTER.toDate' | translate }}" formControlName="toDate">
              </app-to-date>
            </div>

            <div class="fpx-field">
              <label class="fpx-field-label">Payment type</label>
              <div class="search-filter-option">
                <div class="bene-list-filters">
                  <div class="bene-all" [ngClass]="{ active: state.catagoryType == 'all' }"
                    (click)="chooseFilter($event, 'all')">
                    {{ 'PAYMENTS.BENEFICIARY.all' | translate }}
                  </div>
                  <div class="bene-fav" [ngClass]="{ active: state.catagoryType == 'OAT' }"
                    (click)="chooseFilter($event, 'OAT')">
                    {{ 'PAYMENTS.BENEFICIARY.ownAccount_filter' | translate }}
                  </div>
  
                  <div class="bene-fav" [ngClass]="{ active: state.catagoryType == 'INTBT' }"
                    (click)="chooseFilter($event, 'INTBT')">
                    {{ 'PAYMENTS.BENEFICIARY.withInBank_filter' | translate }}
                  </div>
                  <div class="bene-fav" [ngClass]="{ active: state.catagoryType == 'ACH' }"
                    (click)="chooseFilter($event, 'ACH')">
                    {{ 'PAYMENTS.BENEFICIARY.domestic_filter' | translate }}
                  </div>
                  <div class="bene-fav" [ngClass]="{ active: state.catagoryType == 'SWIFT' }"
                    (click)="chooseFilter($event, 'SWIFT')">
                    {{ 'PAYMENTS.BENEFICIARY.international_filter' | translate }}
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </section>
        <div class="center-main">
          <section class="from-button-sec">
            <button type="button" class="btn-link" (click)="reset()">
              <span>{{ 'FORM_ACTIONS.reset' | translate }}</span>
            </button>
          </section>

          <section class="from-button-sec">
            <button type="submit" class="button-common button40 active" [disabled]="formGroup.invalid || state.isDateValid"
              (click)="submit()">
              <span>{{ 'FORM_ACTIONS.search' | translate }}</span>
            </button>
          </section>
        </div>
      </form>
    </div>
  </div>
</div>